// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"c41cf54b","203":"b4d3f73f","551":"bd60a17f","590":"4d6af827","890":"938d67b6","894":"809ebd4b"}[chunkId] + ".chunk.js";
};